import { render, staticRenderFns } from "./NavbarBottom.vue?vue&type=template&id=63e1a36f&scoped=true"
import script from "./NavbarBottom.vue?vue&type=script&lang=js"
export * from "./NavbarBottom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e1a36f",
  null
  
)

export default component.exports